/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { Form, Input, TreeSelect } from 'antd';

const formItemLayout = {
  labelCol: {
    sm: { span: 6 },
  },
  wrapperCol: {
    sm: { span: 16 },
  },
};
const FormItem = Form.Item;

function UpdateForm({
  form,
  item: {
    name,
    remark,
    principal,
    parent_org: parentOrg,
    share_to_orgs: shareToOrgs,
  },
  orgTreeNodes,
}) {
  const { getFieldDecorator } = form;
  return (
    <Form>
      {orgTreeNodes.length ? (
        <FormItem label="父级机构" {...formItemLayout}>
          {getFieldDecorator('parent_org', {
            initialValue: parentOrg || '',
          })(
            <TreeSelect
              showSearch
              style={{ width: '100%' }}
              dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
              placeholder="请选择"
              allowClear
              treeDefaultExpandAll
            >
              {orgTreeNodes}
            </TreeSelect>,
          )}
        </FormItem>
      ) : null}
      <FormItem label="机构名称" {...formItemLayout}>
        {getFieldDecorator('name', {
          rules: [{ required: true, message: '请输入机构名称' }],
          initialValue: name,
        })(<Input />)}
      </FormItem>
      <FormItem label="共享组织" {...formItemLayout}>
        {getFieldDecorator('share_to_orgs', {
          initialValue: shareToOrgs || [],
        })(
          <TreeSelect
            showSearch
            style={{ width: '100%' }}
            dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
            placeholder="请选择"
            allowClear
            treeCheckable
            treeDefaultExpandAll
          >
            {orgTreeNodes}
          </TreeSelect>,
        )}
      </FormItem>
      <FormItem label="负责人" {...formItemLayout}>
        {getFieldDecorator('principal', {
          initialValue: principal,
        })(<Input />)}
      </FormItem>
      <FormItem label="备注" {...formItemLayout}>
        {getFieldDecorator('remark', {
          initialValue: remark,
        })(<Input />)}
      </FormItem>
    </Form>
  );
}

UpdateForm.propTypes = {
  form: PropTypes.shape().isRequired,
  item: PropTypes.shape().isRequired,
  orgTreeNodes: PropTypes.arrayOf(PropTypes.element).isRequired,
};

export default Form.create()(UpdateForm);
